.copyable {
    margin-bottom: 0 !important;

    :global(.ant-typography-copy) {
        margin: 0;
    }
}
